export default "__VITE_ASSET__C5_u9e17__"